import { csv2json } from 'csvjson-csv2json'

export function csvToJson(content: any): any {
  if (typeof content !== 'string') {
    throw new Error('Invalid input, csv input data should be a string')
  }
  return csv2json(content, { parseNumbers: false, parseJSON: true })
}
